en =
    'cozy files configuration 1 on 2': 'Configure your device (1/2)'
    'cozy files configuration 2 on 2': 'Register your device (2/2)'
    'directory to synchronize your data': 'Path of the folder where you will see your cozy files:'
    'your device name': 'The name used to sign up your device to your Cozy:'
    'your remote url': 'The web URL of your Cozy'
    'your remote password': 'The password you use to connect to your Cozy:'
    'go back to previous step': '< Previous step'
    'save your device information and go to step 2': 'Save then go to next step >'
    'register device and synchronize': 'Register then go to next step >'
    'start configuring your device': 'Start to configure your device and sync your files'
    'welcome to the cozy data proxy': 'Welcome to the Cozy Data Proxy, the module that syncs your computer with your Cozy!'
    'path': 'Path'
    'url': 'URL'
    'resync all': 'Resync All'
    'delete configuration': 'Delete configuration'
    'delete configuration and files': 'Delete configuration and files'
    'on': 'on'
    'off': 'off'
    'stop sync': 'Stop sync'
    'device name': 'Device name'
    'sync state': 'Sync state'
    'clear logs': 'Clear logs'
    'delete files': 'Delete files'
    'start sync': 'Start sync'
    'value is missing': 'A value is required for this field.'
    'first step text': """
Prior to register your computer to your Cozy, we need information about it.
"""
    'second step text': """
It's time to register your computer to your Cozy.
(password won't be stored).
"""
